/**
 * @thepit/tokens — Tokens de diseño (SSOT S3).
 *
 * La fuente es `tokens.json`. Este índice expone los valores generados y helpers
 * tipados. El CSS vive en `@thepit/tokens/css` y el preset de Tailwind en
 * `@thepit/tokens/tailwind-preset`.
 */
export * from '../generated/tokens.js';

import { TOKENS, colorVar, DEFAULT_THEME, THEME_ATTRIBUTE, type ThemeName } from '../generated/tokens.js';

/** Colores de esquina, resueltos a variables CSS. */
export const CORNER_COLOR_VAR = {
  red: colorVar('corner', 'red'),
  blue: colorVar('corner', 'blue'),
} as const;

/** Color de esquina según la convención china de mercado: no aplica aquí (son peleadores). */
export function cornerColorVar(corner: 'red' | 'blue'): string {
  return CORNER_COLOR_VAR[corner];
}

export { TOKENS, DEFAULT_THEME, THEME_ATTRIBUTE, colorVar };
export type { ThemeName };

/** Aplica el tema al documento (dark por defecto). */
export function applyTheme(theme: ThemeName, root: HTMLElement = document.documentElement): void {
  root.setAttribute(THEME_ATTRIBUTE, theme);
  root.style.colorScheme = theme;
}

/**
 * Tema inicial. THE PIT es dark-first: el look neón underground es la identidad,
 * así que el default es `dark` sin importar la preferencia del sistema. Solo se
 * usa `light` si la persona lo eligió explícitamente.
 */
export function resolveInitialTheme(stored: string | null): ThemeName {
  if (stored === 'dark' || stored === 'light') return stored;
  return 'dark';
}
